import { apiDETickets } from '@/core/api/';


export default {

    async createUserProfile(profile) {
        try {
            const {data} = await apiDETickets.post("/api/profile/seccreate", profile);
            return data;
        } catch (error) {
            return error;
        }
    },
    async getProfile(userId) {
        try {
            const {data} = await apiDETickets.get("/api/profile?userId=" + userId);
            return data;
        } catch (error) {
            return error;
        }
    },
    async updateProfile(profile) {
        try {
            const {data} = await apiDETickets.put("/api/profile/secupdate", profile);
            return data;
        } catch (error) {
            return error;
        }
    },
    async getDepts() {
        try {
            const {data} = await apiDETickets.get("/api/dept/list");
            return data;
        } catch (error) {
            return error;
        }
    }

}
